<template>
	<h1>Exercices calendrier de l'avent</h1>
	<router-link
		class="submit dark"
		:to="{ name: 'SuperAdminAllPendingCalendarExerciseContent' }"
		>Exercices en attente
	</router-link>
	<nav class="paginate">
		<ul v-if="count !== null">
			<li v-for="(i, index) in paginate()" :key="index">
				<button :class="index == currentPage ? 'active' : ''">
					{{ index }}
				</button>
			</li>
		</ul>
	</nav>
	<table>
		<tr>
			<th></th>
			<th>Titre</th>
			<th>Username</th>
			<th>Voir</th>
			<th>Modifier</th>
			<th>Supprimer</th>
		</tr>
		<tr v-for="(exercise, index) in exercises" :key="index">
			<td>{{ index + 1 }}</td>
			<td>{{ exercise.title }}</td>
			<td>{{ exercise.teacher_name }}</td>
			<td>
				<button @click="showPopUp(exercise, exercise.tile_game_theme)">
					Voir
				</button>
			</td>
			<td>
				<router-link
					:to="{
						name: 'SuperAdminEditCalendarExercise',
						params: { id: exercise.id },
					}"
					>Modifier</router-link
				>
			</td>
			<td>
				<button @click="deleteExercise(exercise.id)">supprimer</button>
			</td>
		</tr>
		<Teleport to="body">
			<pop-up-exo-calendar
				v-if="isPopUpVisible"
				:id="selectedContent.id"
				@close="isPopUpVisible = !isPopUpVisible"
			/>
		</Teleport>
	</table>
</template>

<script>
import { authenticatedApiFetch } from '../../../utils/utils'
import PopUpExoCalendar from '../../PopUp/SeriousGame/Calendar/PopUpExoCalendar.vue'

export default {
	components: { PopUpExoCalendar },
	data() {
		return {
			exercises: [],
			count: null,
			currentPage: 0,
			selectedContent: {},
			isPopUpVisible: false
		}
	},
	methods: {
		showPopUp(e) {
			this.selectedContent = e
			this.isPopUpVisible = !this.isPopUpVisible
		},
		async deleteExercise(id) {
			if (confirm('Voulez vous vraiment supprimer le contenu ?')) {
				await authenticatedApiFetch(`/christmas-calendar-exercises/${id}`, { method: 'DELETE' })
				this.allExercises()
			}
		},
		async allExercises() {
			const res = await authenticatedApiFetch('/christmas-calendar-exercises/?status=PUBLIC', { method: 'GET' })
				.then(res => res.json())

			this.exercises = res
		},
	},

	created() {
		this.allExercises()
	},
}
</script>

<style>
</style>
